import React from "react";
import { useImageFade } from "../../hooks/useImageFade";
import "./ProductCard.css";
import { useCurrency } from "../../Context/CurrencyContext";

export default function ProductCard({ item, onSelect }) {
  const images = item.images?.length > 0 ? item.images : [item.imageUrl];
  const activeIndex = useImageFade(images);
  const { getPrice } = useCurrency();

  return (
    <div className="shop-card" onClick={() => onSelect(item)}>
      <div className="shop-card-img">
        {images.map((src, idx) => (
          <img
            key={src}
            src={src}
            alt={item.name}
            className={`fade-image ${idx === activeIndex ? "active" : ""}`}
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>
      <div className="shop-card-content">
        <h3>{item.name}</h3>
        <p className="shop-card-desc">{item.description}</p>
        <div className="shop-card-footer">
          <span className="shop-price">{getPrice(item)}</span>
          <button
            className="buy-btn"
            onClick={(e) => {
              e.stopPropagation();
              onSelect(item);
            }}
          >
            Quick View
          </button>
        </div>
      </div>
    </div>
  );
}
